export default "__VITE_ASSET__BjjQfaHE__"